export const HiddenIcon = (props) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.25 9.375L48.75 50.625"
      stroke="currentColor"
      strokeWidth="2.8125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.3063 36.9365C34.4664 38.6088 32.0376 39.4817 29.5542 39.3634C27.0707 39.245 24.736 38.145 23.0635 36.3053C21.3911 34.4656 20.5179 32.0369 20.6361 29.5534C20.7542 27.0699 21.854 24.7351 23.6936 23.0625"
      stroke="currentColor"
      strokeWidth="2.8125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3425 16.0762C7.78715 20.915 3.75 29.9996 3.75 29.9996C3.75 29.9996 11.25 46.8727 30 46.8727C34.3931 46.9077 38.7314 45.8958 42.6557 43.9209"
      stroke="currentColor"
      strokeWidth="2.8125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.8928 39.6326C54.0026 35.0559 56.2499 29.9999 56.2499 29.9999C56.2499 29.9999 48.7499 13.1231 29.9999 13.1231C28.376 13.1204 26.7546 13.2525 25.1525 13.5178"
      stroke="currentColor"
      strokeWidth="2.8125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.7642 20.791C33.7568 21.1736 35.5716 22.192 36.9365 23.6934C38.3013 25.1947 39.1425 27.0981 39.334 29.1181"
      stroke="currentColor"
      strokeWidth="2.8125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default HiddenIcon
